import { merge } from "lodash";

import { IBandUserProps } from "Bands/types";
import { APIService } from "shared/services";
import { API_ENDPOINTS, API_ERROR_CODES } from "shared/constants";
import { IDataKeys, IJSONAPIItem, IAPIError } from "shared/types";

interface IJSONAPIBandUser {
  [key: string]: IJSONAPIItem;
}

export interface IJSONAPIBandUserCollection {
  [IDataKeys.bandUser]: IJSONAPIBandUser;
  meta: {
    [key: string]: IJSONAPIItem;
  };
  pagination: any;
}

export class BandUserService {
  static getBandUsers = (
    queryParams?:
      | string
      | { [key: string]: string | number | undefined | string[] }
  ): Promise<IJSONAPIBandUserCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const bandUsers: unknown = await APIService.get({
          path: API_ENDPOINTS.BAND_USERS,
          data: queryParams,
        });

        resolve(
          merge(
            { [IDataKeys.bandUser]: {} }, // if data is empty, return empty object for key
            bandUsers
          ) as IJSONAPIBandUserCollection
        );
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_BAND_USERS);
        return reject(error);
      }
    });

  static editBandUser = (
    bandUserId: string,
    bandUser: IBandUserProps
  ): Promise<IJSONAPIBandUserCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const patchedBandUser: unknown = await APIService.patch({
          path: API_ENDPOINTS.BAND_USER(bandUserId),
          data: bandUser,
        });
        resolve(patchedBandUser as IJSONAPIBandUserCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.PATCH_BAND_USER);
        reject(error);
      }
    });

  static deleteBandUser = (bandUserId: string): Promise<void> =>
    new Promise(async (resolve, reject) => {
      try {
        await APIService.delete({
          path: API_ENDPOINTS.BAND_USER(bandUserId),
        });
        resolve();
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.DELETE_BAND_USER);
        reject(error);
      }
    });

  static getMyBandUsers = (
    queryParams?:
      | string
      | { [key: string]: string | number | undefined | string[] }
  ): Promise<IJSONAPIBandUserCollection> =>
    new Promise(async (resolve, reject) => {
      try {
        const bandUsers: unknown = await APIService.get({
          path: API_ENDPOINTS.BAND_USERS_ME,
          data: queryParams,
        });

        // const bandUsersData = bandUsers as IJSONAPIBandUserCollection;

        // const userBands = Object.values(bandUsersData[IDataKeys.bandUser]).map(
        //   (bandUser) => (bandUser.attributes?.band as IJSONAPIData).data
        // );

        // const userBandsById = keyBy(userBands, "id");

        resolve(bandUsers as IJSONAPIBandUserCollection);
      } catch (error) {
        (error as IAPIError).errorCodes?.push(API_ERROR_CODES.GET_BANDS);
        reject(error);
      }
    });
}
